import AbstractScene from './AbstractScene.js';
import RoundedButton2 from '../prefabs/RoundedButton2.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import Deck3 from '../prefabs/game3/Deck3.js';
import Zone3 from '../prefabs/game3/Zone3.js';
import EndBoard from '../prefabs/EndBoard.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame3';

export default class Game3 extends AbstractScene {
    constructor() {
        super({
            key: "Game3"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
        this.zones = []
        this.allZonesDone = []
    }

    preload() {
        this._preload();
    }

    create() {
        CartesInfos.sort(() => Math.random() - 0.5);
        this.background = this.add.image(0, 0, 'background3').setOrigin(0);
        this.addDropZone()
        this.addAllLittleCards()
        this.transitionRect = this.add.rectangle(16, 16, 1888, 1048, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0).setDepth(12)
        this.deck = new Deck3(this, 1043, 921);
        this.deck.setDeckAction(CartesInfos[0])
        this.transitionIn()
    }
    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 960, false);
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            this.zones.forEach(zone => {
                zone.setActive();
            });
        })
    }

    addDropZone() {
        for (let i = 0; i < ZonesInfos.length; i++) {
            const element = ZonesInfos[i];
            let zone = new Zone3(this, element);
            this.zones.push(zone)
        }

    }

    addAllLittleCards() {
        for (let i = 0; i < ZonesInfos.length; i++) {
            const element = ZonesInfos[i];
            let card = this.add.image(element.zoneX, element.zoneY, element.image).setOrigin(0.5).setDepth(0).setAlpha(0)
            card.setScale(0.5)
            card.setName(element.trueId)
            this.allZonesDone.push(card)
        }
    }


    replaceItem(x, y, itemData) {
        let selectedCard = this.allZonesDone.find(card => card.name === itemData.trueId);
        selectedCard.setAlpha(1)
        // selectedCard.setInteractive();
        // selectedCard.on('pointerout', () => { 
        //     selectedCard.setScale(0.5) 
        //     selectedCard.setDepth(0)
        // })
        // selectedCard.on('pointerover', () => { 
        //     selectedCard.setScale(1) 
        //     selectedCard.setDepth(1)
        // })
        // }

        // this.zoneDone = new Zone3Done(this, x, y, itemData)
        // let img = this.add.image(x, y, itemData.image).setOrigin(0.5)
        // img.setInteractive();
        // img.setName(itemData.trueId)
        // img.on('pointerout', () => { img.setScale(0.5) })
        // img.on('pointerover', () => { img.setScale(1) })
        // this.allZonesDone.push(img)

    }
    launchEndBoard() {
        this.deck.subtitle.setText("\nMESURES DE PRÉVENTION ET\nDE TRAITEMENT DES DIFFICULTÉS\nDES ENTREPRISES")
        new EndBoard(this, this.game.data.score)
    }
    transitionIn() {
        // this.transitionRect.setAngle(180);
        this.tweens.add({
            targets: this.transitionRect,
            duration: 500,
            ease: 'Linear',
            x: 1920,
            onComplete: () => {
                this.launchPopup();
                // this.deck.setAlpha(1)
            }
        })

    }
}